// test1840
(1840 && 0);
